import React from "react";
import Select from "react-select";
import { lineColors } from "./FunctionAutoTopology";
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_USER } from "../Optics/Constants/ConstantsOptics";

const AutoTopologySidebar = ({
  canton,
  selectedCanton,
  handleCantonChange,
  regions,
  selectedRegionRef,
  handleRegionChange,
  area,
  selectedAreaRef,
  handleAreaChange,
  handleClick,
  loading,
  layersVisibility,
  toggleLayerVisibility,
  linesVisibility,
  toggleLineVisibility,
  customStyles
}) => {


            const roleId = localStorage.getItem('roleId');
          const territory = localStorage.getItem('territory');

          const allowedRoles = [ROLE_ADMIN, ROLE_ENGINNER, ROLE_USER];
          const showHighwayContainer = allowedRoles.includes(roleId);

          const cantonToUse = getFilteredCanton(territory, canton, roleId);

          function getFilteredCanton(territoryRaw, canton, roleId) {
            const userTerritory = (territoryRaw || '').trim();

            if (roleId === ROLE_ADMIN || roleId === ROLE_ENGINNER) {
              return canton; // полный доступ
            }

            if (userTerritory.toLowerCase() === 'full') {
              return canton;
            }

            if (!userTerritory) {
              return []; // ничего не передаём
            }
             // работает по мастерам только один округ показывает 
            // const normalizedCanton = canton.map(c => c.trim());
            // return normalizedCanton.includes(userTerritory) ? [userTerritory] : [];

             // работает по мастерам все их округа показывает 
            const normalizedCanton = canton.map(c => c.trim());

              const userTerritories = userTerritory
                  .split(',')
                  .map(t => t.trim());

              return normalizedCanton.filter(c =>
                  userTerritories.includes(c)
              );
          }

            // const roleId = localStorage.getItem('roleId');
            // const territory = localStorage.getItem('territory');
  
  
            // const cantonToUse = getFilteredCanton(territory, canton, roleId);
  
            // function getFilteredCanton(territoryRaw, canton, roleId) {
            //   const userTerritory = (territoryRaw || '').trim();
  
            //   if (roleId === ROLE_ADMIN || roleId === ROLE_ENGINNER) {
            //     return canton; // полный доступ
            //   }
  
            //   if (userTerritory.toLowerCase() === 'full') {
            //     return canton;
            //   }
  
            //   if (!userTerritory) {
            //     return []; // ничего не передаём
            //   }
  
            //   const normalizedCanton = canton.map(c => c.trim());
            //   return normalizedCanton.includes(userTerritory) ? [userTerritory] : [];
            // }

  return (
    <div style={{ flex: "1 1 15%", paddingLeft: "5px", paddingRight: "5px" }}>
      {/* Территория */}
      <div className="divBodyAutoTopology">
        <label className="textTitleDrawer" style={{textShadow: '2px 2px 4px #0a0a0aff'}}>Территория</label>
        <hr
          className="horizontalLineDrawer"
          style={{ marginTop: "5px", marginBottom: "10px", background: "#cccccc" }}
        />
        <Select
          className="selectSearchDrawer"
          value={selectedCanton.value}
          onChange={handleCantonChange}
          options={cantonToUse.map((option) => ({ value: option, label: option }))}
          isSearchable={true}
          styles={customStyles}
          placeholder="Округ"
        />

        <select
          className="selectAutoTopology"
          onChange={handleRegionChange}
          ref={selectedRegionRef}
        >
          <option value="null">Регион</option>
          {regions.map((region, index) => (
            <option key={index} value={region}>
              {region}
            </option>
          ))}
        </select>

        <select
          className="selectAutoTopology"
          style={{ marginTop: "5px", marginLeft: "5px" }}
          onChange={handleAreaChange}
          ref={selectedAreaRef}
        >
          <option value="null">Ветка</option>
          {area.map((areaItem, index) => (
            <option key={index} value={areaItem}>
              {areaItem}
            </option>
          ))}
        </select>

        <button
          className="buttonAutoTopology"
          onClick={handleClick}
          disabled={loading}
        >
          Отобразить
        </button>
        {loading && (
          <img src="loading.gif" alt="Загрузка..." width="30" height="30" />
        )}
      </div>

      {/* Оборудование */}
      <div className="divBodyAutoTopology">
        <label className="textTitleDrawer" style={{textShadow: "2px 2px 4px #000000ff"}}>Узлы</label>
        <hr
          className="horizontalLineDrawer"
          style={{ marginTop: "5px", marginBottom: "10px",  background: "#cccccc"}}
        />
    <div
    style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr", // 2 колонки
        gap: "2px 10px",               // расстояние между строками и колонками
    }}
    >
  {[
    { key: "icon100k", label: "100K" },
    { key: "icon30k", label: "30K" },
    { key: "icon3k", label: "3K" },
    { key: "icon100pab", label: "100ПАБ" },
    { key: "iconKp", label: "КП" },
  ].map((item) => (
    <div key={item.key} style={{ display: "flex", alignItems: "center" }}>
      <input
        type="checkbox"
        checked={layersVisibility[item.key]}
        onChange={() => toggleLayerVisibility(item.key)}
        disabled={loading}
        style={{ marginRight: "5px" }}
      />
      <label
        style={{
          marginRight: item.key === "iconKp" ? 0 : "10px",
          textShadow: '2px 2px 4px #0a0a0aff',
          color: "#cccccc",
        }}
      >
        {item.label}
      </label>
    </div>
  ))}
</div>
      </div>

      {/* Линки */}
      <div className="divBodyAutoTopology" style={{ marginTop: "10px" }}>
        <label className="textTitleDrawer" style={{textShadow: "2px 2px 4px #000000ff"}}>Линки</label>
        <hr
          className="horizontalLineDrawer"
          style={{ marginTop: "5px", marginBottom: "10px",  background: "#cccccc" }}
        />
        {[
          { key: "orange", label: "100K-30K" },
          { key: "orange2", label: "30K-30K" },
          { key: "blue", label: "100K-3K" },
          { key: "blue2", label: "30K-3K" },
          { key: "red", label: "3K-3K" },
          { key: "green", label: "3K-100ПАБ" },
          { key: "purple", label: "100ПАБ-100ПАБ" },
          { key: "black", label: "Другое" },

        
        ].map((item) => (
          <div key={item.key} style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              checked={linesVisibility[item.key]}
              onChange={() => toggleLineVisibility(item.key)}
              disabled={loading}
              style={{ marginRight: "5px" }}
            />
            <label
                style={{
                    marginRight: "10px",
                    color: "#cccccc",
                    textShadow: "2px 2px 4px #292929ff",
                    display: "flex",
                    alignItems: "center",
                }}
                >
                {item.label}
                <span
                    style={{
                    display: "inline-block",
                    width: "20px",      
                    height: "4px",      
                    backgroundColor: lineColors[item.key] || "transparent",
                    marginLeft: "6px",  
                    borderRadius: "5px",
                    }}
                />
                </label>
          
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutoTopologySidebar;